import { createSlice } from "@reduxjs/toolkit";

// Stores the current viewport width so layout components can react to screen-size changes
// from one centralized place.
const screenSize = createSlice({
  name: "screenSize",
  initialState: {
    screenSize: 0,
  },
  reducers: {
    // Update the shared screen-size value whenever the app recalculates the viewport.
    addScreenSize: (state, action) => {
      state.screenSize = action.payload;
    },
  },
});

export const { addScreenSize } = screenSize.actions;

export default screenSize.reducer;
